import { render, staticRenderFns } from "./CrmOrderLostDetail.vue?vue&type=template&id=1c39add4&scoped=true"
import script from "./CrmOrderLostDetail.vue?vue&type=script&lang=js"
export * from "./CrmOrderLostDetail.vue?vue&type=script&lang=js"
import style0 from "./CrmOrderLostDetail.vue?vue&type=style&index=0&id=1c39add4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39add4",
  null
  
)

export default component.exports